
import * as React from "react";
import { AppBar, Badge, Box, IconButton, Link, Menu, MenuItem, Toolbar, Typography } from "@mui/material";
import ModeNightRoundedIcon from '@mui/icons-material/ModeNightRounded';
import WbSunnyRoundedIcon from '@mui/icons-material/WbSunnyRounded';

import Service from "../../../util/Service";
import EditComp from "../../util/EditComp";
import EditarPaginaHtml from "../editar/EditarPaginaHtml";
import CodeContentPage from "./CodeContentPage";
import ContentPage from "./ContentPage";

export default function LayoutHeader(props) {
    const { darkMode, handleDarkMode, edit, pageRoot } = props;
    
    const [pagina, setPagina] = React.useState();
    const [wait, setWait] = React.useState(false);
    const [openEditar, setOpenEditar] = React.useState(false);
    
    React.useEffect(() => {
        setWait(true);
    
        const h = pageRoot.layout.header.pagina || 'Header';
        Service.GET('/api/paginaHtml/buscaPorNome/' + h).then(r => {            
            if (r && r.length > 0) {
                setPagina(r[0]);
            }
            setWait(false)
        });
    }, [])

    // function handleEditarPagina() {
    //     if( !pagina){
    //         let dado = {
    //             nome: pageRoot.layout.header.pagina,
    //             descricao: 'Pagina Cabeçalho'
    //         }

    //         Service.POST("/api/security/paginaHtml", dado).then(r => {
    //             setPagina( r );
    //             setOpenEditar(true);
    //         }).catch(e =>{
    //             console.error( "erro--->", e )
    //             alert( e);
    //         })
    //     }else{
    //         setOpenEditar(true);
    //     }
    //     setOpenEditar(true);
    // }
    function handelDoAction(retorno) {
        setPagina(retorno);
    }
    
    if (wait) {
        return (
            <AppBar key={"appBar-1"} position="static" color="transparent" >
                <IconButton
                    size="small"
                    aria-label="account of current user"
                    aria-controls="menu-appbar-3"
                    aria-haspopup="true"
                    color="inherit"
                >
                    aguarde...
                </IconButton>
            </AppBar>
        )
    }
    if (pagina && pagina.codigo) {             
        let style = null;
        if( pagina.estilo){
          style = {}
          const arr = pagina.estilo.split(";")      
          for( let x of arr){
            if( x.length > 1){
              let sp = x.split(":")
              let key = sp[0];
              const val = sp[1];
              sp = key.split('-');
              if( sp.length > 1){
                key = sp[0]+sp[1].charAt(0).toUpperCase() + sp[1].slice(1);                
              }              
              style[key] = val;
              style.flexGrow = 1;
            }
          }
        }   
        return (            
            <Box sx={ style?style:{ flexGrow: 1, background: "#141c30" }}>
                {pagina.codigo.blocks.map((row, index) => {
                    return (
                        <CodeContentPage
                            key={index} bloco={row} darkMode={darkMode} handleDarkMode={handleDarkMode} edit={edit} pagina={pagina} pageRoot={pageRoot}
                            style={style}
                        />
                    )
                })}
            </Box>
        )
    }
    if (pagina && pagina.pagina) {
        return (
            <Box sx={{ flexGrow: 1 }}>
                <ContentPage pagina={pagina} edit={edit}/>
            </Box>
        )
    }
    
    return (
        <React.Fragment>
            <AppBar position="static" color="transparent" key={"appBar-2"}>
                <Toolbar>
                    <Typography variant="h6" component={'a'} href="/" sx={{
                        textAlign: 'center'
                    }}>
                        Cabeçalho padrão
                    </Typography>
                    <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
                        
                    </Box>
                    <Box
                        sx={{
                            typography: 'body1',
                            '& > :not(style) ~ :not(style)': {
                                ml: 2,
                            },
                        }}
                    >
                        <Link href="/recursos">Administrar Portal</Link>
                        <Link href="/gerenciar">Gerenciar</Link>
                    </Box>
                    
                    <Box >
                        <IconButton
                            size="small"
                            aria-label=""
                            color="inherit"
                            onClick={handleDarkMode}
                        >
                            {darkMode ? <WbSunnyRoundedIcon /> : <ModeNightRoundedIcon />}
                        </IconButton>
                    </Box>
                    {/* <Box >
                        <EditComp tip="Editar Pagina" action={handleEditarPagina} edit={edit} float={false} />
                    </Box> */}
                </Toolbar>
            </AppBar>
            <EditarPaginaHtml open={openEditar} setOpen={setOpenEditar} doAction={handelDoAction} pagina={pagina} />
        </React.Fragment>
    );
}